import './accordion-listing.scss'
import { P2Accordion } from 'react-bootstrap-common-script'
import { Helpers } from '../../../../../utils/helper'
import { TextInfo } from '../../../../text'
import { MaritalStatusCode, NationalityCode, RelationshipWithOwner, ResidentialStatus } from '../../../../../utils/code-converter'
import { ResidentialStatusEnum } from '../../../../../models/enum/residential-status.enum'
import { MaritalStatusEnum } from '../../../../../models/enum/marital-status.enum'
import { idTypesInterface, ownerChildrenCareItems } from '../../../../../utils/shared-dropdown'
import { useAppSelector } from '../../../../../redux/hook'
import { useState } from 'react'

interface Props {
  type : string,
}

const AccordionListing = ({type} : Props) => {
  const [toggled, setToggled] = useState<boolean[]>([]);
  const applicationStep1 = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const data = (type == "owner" ? applicationStep1.household.incoming_owners : applicationStep1.household.incoming_occupiers);
  const mainOwner =  applicationStep1.household.incoming_owners[0].myinfo.name 

  const handleToggle = (index : number) => {
    setToggled(prev => {
      const updatedToggled = [...prev];
      updatedToggled[index] = !updatedToggled[index];
      return updatedToggled;
    });
  };
  return (
    <div className='polymer-accordion-listing'>
      { data &&
        data.map((owner : any, index : number) => {
          return <P2Accordion key={index} defaultOpen={false}  onToggle={() => handleToggle(index)} title={
            <div className='polymer-accordion-listing_title'>
              <h4>{owner.myinfo.name}</h4>
              {toggled[index] &&  <p>{Helpers.maskPartialContent(owner.myinfo.uinfin)}</p>}
            </div>
          }>
            <div className='polymer-accordion-listing_content'>
              {owner.is_related && owner.myinfo.name != mainOwner && <div className='polymer-accordion-listing_content-section'>
                <h1>Relationship</h1> 
                <TextInfo variant='column' title={`Is the incoming owner related to ${mainOwner}?`} description={owner.is_related ? "Yes" : "No"} /> 
                <TextInfo variant='column' title={`How is this proposed owner related to the ${mainOwner}?`} description={RelationshipWithOwner.find(item => item.code === owner.relationship_with_owner)?.hdb_description} />
              </div>}

              <div className='polymer-accordion-listing_content-section'>
                <h1>Personal</h1>
                <TextInfo variant='column' title={`Full name as per NRIC`} description={owner.myinfo.name} />
                <TextInfo variant='column' title={`Nationality`} description={NationalityCode.find(item => item.code === owner.myinfo.nationality)?.description} />
                <TextInfo variant='column' title={`Residential Status`} description={ResidentialStatus.find(item => item.code === owner.myinfo.residential_status)?.description} />

                {type == "owner"  && owner.myinfo.residential_status === ResidentialStatusEnum.pr && <TextInfo variant='column' title={`Date of SPR Obtained`} description={owner.spr_obtained_date} />}

                <TextInfo variant='column' title={`Marital Status`} description={MaritalStatusCode.find(item => item.code === owner.myinfo.marital_status)?.description} />
                {owner.myinfo.marital_status === MaritalStatusEnum.divorced && owner.children_care_and_control && <TextInfo variant='column' title={`Does this owner have care and control of his/her children?`} description={ownerChildrenCareItems.find(item => item.value === owner.children_care_and_control)?.title} />}

                {type == "owner"  &&  owner.myinfo.marital_status === MaritalStatusEnum.married && <TextInfo variant='column' title={`Identification type of spouse`} description={idTypesInterface.find(item => item.value === owner.spouse_id_type)?.title} />}
                {owner.myinfo.marital_status === MaritalStatusEnum.married && <TextInfo variant='column' title={`Identity number of spouse`} description={Helpers.maskPartialContent(owner.spouse)} />}

              </div>
            </div>
          </P2Accordion>
        })
      }
    </div>
  )
}

export default AccordionListing